<label class="soft-label soft-label-top w-full mb-0.5" [class.required]="required">{{ label }}</label>
<ng-container [formGroup]="formGroup">
  <soft-entity-input #entityInput
    (keydown.arrowDown)="highlightNext()"
    (keydown.escape)="canceled(entityInput)"
    (keydown.enter)="selectHighlightedProduct()"
    (keydown.arrowUp)="highlightPrevious()"
    [value]="(value$ | async) ?? null"
    [readonly]="readonly"
    (cancel)="canceled()"
    (close)="closed()"
    (valueChange)="valueChanged($event)"
    (validate)="onValidate($event)"
    (inputChange)="inputChanged($event)"
    [strategy]="strategy"
    class="mt-0.5"
    [formControlName]="controlName">

    <ng-template #entityTemplate let-entity="entity">
      <ng-container *ngTemplateOutlet="selectedTemplate || defaultTemplate; context: { $implicit: entity, entity }"></ng-container>
      <ng-template #defaultTemplate>
        {{ entity?.id }} - {{ entity?.[controlName] }}
      </ng-template>
    </ng-template>

    <lib-input-content-view
      [views]="views"
      [selected]="(selectedView$ | async) ?? 'results'"
      (selectedChange)="selectedView$.next($event)"
      [createTemplate]="createTemplate"
      [editTemplate]="editTemplate"
      [resultTemplate]="resultTemplate">
    </lib-input-content-view>

    <ng-template #resultTemplate>
      @if ({ index: highlightedIndex$ | async }; as highlighted) {
        @if (filteredEntities$ | async; as products) {
          <ul class="w-full h-full my-0" >
            @for (entity of products; track trackByFn(i, entity); let last = $last; let i = $index) {
              <li
                [scrollIntoView]="highlighted.index === i"
                (mouseenter)="highlightedIndex$.next(i)"
                (mouseleave)="highlightedIndex$.next(-1)"
                [class.bg-secondary-200]="highlighted.index === i"
                [ngClass]="!last ? 'border-b border-solid' : ''"
                class="pl-2 w-full !flex flex-col">
                <ng-container *ngTemplateOutlet="entityResultTemplate; context: { $implicit: entity, highlighted: highlighted.index === i }"></ng-container>
              </li>
            }
          </ul>
        }
      }
    </ng-template>

    <ng-template #editTemplate>
      @if ({ product: entityInEditing$ | async }; as productInEditing) {
        <ng-container *ngTemplateOutlet="entityEditTemplate; context: { $implicit: productInEditing.product }"></ng-container>
      }
    </ng-template>

    <ng-template #createTemplate>
      <ng-container *ngTemplateOutlet="entityCreateTemplate"></ng-container>
    </ng-template>
  </soft-entity-input>
</ng-container>

<ng-template #emptyTemplate>
  Empty Template
</ng-template>
